/**
 * @name hasRTLContext
 * @deprecated This utility is deprecated and will be removed in the next major version. Please, use `DirectionService` instead.
 * @description Checks if the given element is within an element that has the [dir="rtl"] attribute
 *
 * @example
 * import { hasRTLContext } from '@workbench/core';
 *
 * hasRTLContext(element); // true
 */
export function hasRTLContext(element: HTMLElement): boolean {
  return Boolean(element.closest('[dir="rtl"]'));
}
